import { Typography } from '@mui/material';
import Button from '@mui/material/Button';
import ButtonGroup from '@mui/material/ButtonGroup';
import { Icon } from '@mui/material';
import linkedin from "./images/linkedin.png"
import github from "./images/github.png"
import "../styles/Hello.css"


// button group as links 
//paper

const Hello = (props) => {

    return (
        <div ref={props.refProp }>
            <div className="hello-container">
                <div>
                    <p className="text0">Hello I'm</p>
                    <h1 className="text1" >
                        Fatih Durmaz
                    </h1>

                    <h3 className="text2">
                        Senior Computer Science and Engineering Student in Sabanci University
                        </h3>
                        

                </div>
            </div>
            <div className="button-box">
                <Button href="mailto: fatihdurmaz@sabanciuniv.edu">Get In Touch</Button>
                <Icon></Icon>
                <div className="button-group">
                    
                    <ButtonGroup variant="text">
                        <Button href="https://www.linkedin.com/in/fatihdurmaz99/">
                            <img src={linkedin} height={30} width={38}></img>
                        </Button>
                        <Button href="https://github.com/fthdrmzzz">
                            <img src={github} height={30} width={30}></img>
                        </Button>
                    </ButtonGroup>
                </div>
                </div>
        </div>
    )
}

export default Hello